import { fetcher, IGlobalRequestOptions } from "common/api/Fetcher";
import { IAccessData } from "common/records/Access";
import { IMetaPaginationData } from "common/records/MetaPagination";
import { AccessParamsRecord } from "common/records/index/AccessParams";
import { toParams } from "common/records/index/QueryParamsBase";
import { Nullable } from "common/types";

export interface IAccessIndexResponse {
  accesses: IAccessData[];
  meta: { pagination: IMetaPaginationData };
}

export interface IAccessShowResponse {
  access: IAccessData;
  error?: string;
}

export interface IBatchCheckResponse {
  results: IBatchCheckResult[];
}

export interface IBatchCheckResult {
  user_id: number;
  access_id: Nullable<number>;
}

export const Billables = <const>["billable", "free", "estimates", "leads"];
export type Billable = (typeof Billables)[number];

export const url = "api/v1/users/:id/accesses";

export const list = (
  queryParams: AccessParamsRecord,
  options?: IGlobalRequestOptions,
): Promise<IAccessIndexResponse> => {
  const parameters = toParams(queryParams);
  delete parameters.userId;
  parameters["include[]"] = ["acl"];

  const actionUrl = url.replace(":id", queryParams.userId.toString());

  return options
    ? fetcher.get<IAccessIndexResponse>(actionUrl, parameters, options)
    : fetcher.get<IAccessIndexResponse>(actionUrl, parameters);
};

export const getAccess = (user_id: number, org_id: number): Promise<IAccessShowResponse> => {
  const actionUrl = `api/v1/users/${user_id}/accesses/by_org_id`;
  return fetcher.get<IAccessShowResponse>(actionUrl, { user_id, org_id, include: ["config"] });
};

export const updateAccess = (access_id: number, config: any): Promise<IAccessShowResponse> => {
  const actionUrl = `api/v1/accesses/${access_id}`;
  return fetcher.patch<IAccessShowResponse>(actionUrl, { config });
};

export const batchCheck = (org_id: number, user_ids: number[]): Promise<IBatchCheckResponse> => {
  const actionUrl = `api/v1/orgs/${org_id}/accesses/batch_check`;
  return fetcher.post<IBatchCheckResponse>(actionUrl, { user_ids }, { useGlobalNotFoundRedirect: false });
};
